import { formatDayLabel, getDateInPreferredTimezone } from '../utils/dates';

export const reshapeLocations = locations => {
    return locations.reduce((locations, currentLocations) => {
        locations[currentLocations.id] = currentLocations;

        if (!Array.isArray(currentLocations.sublocations)) {
            return locations;
        }

        locations[currentLocations.id].sublocations = currentLocations.sublocations.reduce(
            (object, sublocation) => ({ ...object, [sublocation.id]: sublocation }),
            {}
        );

        return locations;
    }, {});
};

export const makeEventDaysTimestampPreferredTimezone = (
    startDateUTC: number,
    endDateUTC: number,
    timezone?: string
) => {
    const MILLISECONDS_PER_DAY = 60 * 60 * 24 * 1000; //86400000;
    const startDateUserTimezone = getDateInPreferredTimezone(startDateUTC, timezone);
    const endDateUserTimezone = getDateInPreferredTimezone(endDateUTC, timezone);

    const timestamps: number[] = [];
    let timestamp = startDateUserTimezone;

    do {
        timestamps.push(timestamp);
        timestamp += MILLISECONDS_PER_DAY;
    } while (timestamp <= endDateUserTimezone);

    return timestamps;
};

export const patchDatesLabelMapping = (
    eventDaysTimestamps: number[],
    datesLabelMapping: Record<string, string> = {}
) => {
    const timezoneLabelEntries = Object.entries(datesLabelMapping)
        .map(([prefixedTimestamp, label]) => [prefixedTimestamp.replace('day-', ''), label])
        .filter(([key]) => Number(key));

    const patchedDateLabelMapping = eventDaysTimestamps.reduce(
        (acc, timestamp, i) => {
            const defaultLabel = formatDayLabel(timestamp);
            const label = timezoneLabelEntries[i]?.[1] ?? defaultLabel;
            acc[timestamp] = label;
            return acc;
        },
        { unscheduled: datesLabelMapping?.['not-scheduled'] }
    );

    return patchedDateLabelMapping;
};
